// extracted by mini-css-extract-plugin
export default {"resetPasswordContainer":"PasswordResetForm_resetPasswordContainer__eV8aq"};